// Credit card sync feature is currently disabled.
// To re-enable, restore the API call below.
// import { creditCardSyncApi } from "@/lib/api";

interface FeatureFlags {
  creditCardSync: boolean;
  loading: boolean;
}

export function useFeatureFlags(): FeatureFlags {
  return { creditCardSync: false, loading: false };

  /* Original implementation – restore to re-enable:
  const [flags, setFlags] = useState<FeatureFlags>({
    creditCardSync: false,
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;
    creditCardSyncApi
      .isFeatureEnabled()
      .then((res) => {
        if (!cancelled) {
          setFlags({ creditCardSync: res.enabled, loading: false });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setFlags({ creditCardSync: false, loading: false });
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return flags;
  */
}
